<template>
  <div class="app-container">
    <el-row :gutter="20">
      <!--部门数据-->
      <el-col :span="5" :xs="24">
        <div class="head-container">
          <el-input v-model="projectName" placeholder="请输入项目名称" clearable size="small" prefix-icon="el-icon-search" style="margin-bottom: 20px" @keyup.enter.native="filterTree" />
        </div>

        <!--材料分类树-->
        <div class="head-container tree-container">
          <!-- 新增按钮，点击后弹出新增行业或种类弹窗 -->
          <div style="margin-bottom: 10px; text-align: right;">
            <!-- 新增按钮 -->
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd">
              新增
            </el-button>
          </div>
          <div class="tree-wrapper">
            <el-tree :data="treeData" :props="defaultProps" node-key="id" default-expand-all @node-click="handleNodeClick" :filter-node-method="filterTreeNode" ref="projectTree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span :class="'node-' + data.type">
                  <span class="node-indicator"></span>
                  {{ node.label }}
                </span>
                <span class="tree-actions">
                  <!-- 只有level小于4的节点才显示新增按钮 -->
                  <!-- <el-button v-if="data.level < 4" type="primary" size="mini" icon="el-icon-plus" circle @click.stop="() => handleAddChild(data)"></el-button> -->
                  <!-- <el-button type="success" size="mini" icon="el-icon-plus" circle @click="() => handleAddType(data)"></el-button> -->
                  <!-- <el-button type="warning" size="mini" icon="el-icon-plus" circle @click="() => handleAddProject(data)"></el-button> -->
                  <el-button v-if="!data.children || data.children.length === 0" type="danger" size="mini" icon="el-icon-delete" circle @click.stop="() => handleDeleteNode(data)"></el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-col>

      <!--用户数据-->
      <el-col :span="19" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span v-if="currentNode">
              <i :class="getNodeIcon(currentNode.type)"></i>
              当前选择: {{currentNode.name}} ({{getNodeTypeName(currentNode.type)}})
            </span>
            <span v-else><i class="el-icon-document"></i> 项目详情</span>
          </div>

          <!-- 表单内容滚动容器：避免内容超出后被遮挡 -->
          <div class="form-scroll">
            <el-form ref="form" :model="form" label-width="140px">

              <!-- level-1 类别表单 -->
              <el-row v-show="currentFormLevel === 1">
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="类别名称">
                      <el-input v-model="form.reportTypeName" placeholder="请输入类别名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="排序">
                      <el-input v-model="form.reportTypeIdx" placeholder="请输入排序"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-row>

              <!-- level-2 检测报告表单 -->
              <el-row v-show="currentFormLevel === 2">
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="检测报告编号">
                      <el-input v-model="form.configReportCode" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="检测报告名称">
                      <el-input v-model="form.configReportName" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="检测项目规格1">
                      <el-input v-model="form.configReportSpecs1" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="检测项目规格2">
                      <el-input v-model="form.configReportSpecs2" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="检测项目规格3">
                      <el-input v-model="form.configReportSpecs3" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="检测项目排序">
                      <el-input v-model="form.configReportIndex" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="是否启用">
                      <el-switch v-model="form.enableState" :active-value="'1'" :inactive-value="'0'"></el-switch>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属机构">
                      <el-select v-model="form.tenantPid" filterable placeholder="请选择所属机构" style="width: 100%">
                        <el-option v-for="opt in departmentOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">

                  <el-col :span="12">
                    <el-form-item label="所属设备">
                      <!-- 设备选择输入框 -->
                      <el-input v-model="selectedDevicesDisplay" placeholder="请点击查询选择设备" readonly @focus="blurInput" clearable @clear="DeleteProjNums">
                        <el-button slot="append" icon="el-icon-search" @click="getAllengineeringName">
                        </el-button>
                      </el-input>
                      <!-- 已选设备标签显示 -->
                      <div v-if="selectedDevices.length > 0" class="selected-devices-tags" style="margin-top: 8px;">
                        <el-tag v-for="device in selectedDevices" :key="device.value" closable @close="removeDevice(device)" style="margin-right: 8px; margin-bottom: 4px;">
                          {{ device.label }}
                        </el-tag>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属标准">
                      <!-- 标准选择输入框 -->
                      <el-input v-model="selectedStandardsDisplay" placeholder="请点击查询选择标准" readonly @focus="blurInput" clearable @clear="clearStandardSelection">
                        <el-button slot="append" icon="el-icon-search" @click="openStandardDialog">
                        </el-button>
                      </el-input>
                      <!-- 已选标准标签显示 -->
                      <div v-if="selectedStandards.length > 0" class="selected-standards-tags" style="margin-top: 8px;">
                        <el-tag v-for="standard in selectedStandards" :key="standard.value" closable @close="removeStandard(standard)" style="margin-right: 8px; margin-bottom: 4px;">
                          {{ standard.label }}
                        </el-tag>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="所属报告模板">
                      <!-- 单选下拉：报告模板，数据源自 queryAllTemplatePidAndName，过滤 templateType=0 -->
                      <el-select v-model="form.templatePids" filterable placeholder="请选择" style="width: 100%">
                        <el-option v-for="opt in reportTemplateOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="所属原始记录模板">
                      <!-- 单选下拉：原始记录模板，数据源自 queryAllTemplatePidAndName，过滤 templateType=1 -->
                      <el-select v-model="form.templateOriginalPids" filterable placeholder="请选择" style="width: 100%">
                        <el-option v-for="opt in originalTemplateOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="12">
                    <el-form-item label="监管设备名称" prop="jgEqpName">
                      <el-select v-model="form.jgEqpName" multiple filterable placeholder="请选择监管设备名称" style="width: 100%">
                        <el-option v-for="opt in jgEqpNameOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="匹配记录界面" prop="matchRecord">
                      <el-select v-model="form.matchRecord" filterable placeholder="请选择匹配记录界面" style="width: 100%">
                        <el-option key="自动扶梯" label="自动扶梯" value="自动扶梯原始记录" />
                        <el-option key="自动人行道" label="自动人行道" value="自动人行道原始记录" />
                        <el-option key="曳引式客梯" label="曳引式客梯" value="曳引式客梯" />
                        <el-option key="曳引式货梯" label="曳引式货梯" value="曳引式货梯" />
                        <el-option key="曳引驱动杂物电梯" label="曳引驱动杂物电梯" value="曳引驱动杂物电梯" />
                        <el-option key="消防员电梯" label="消防员电梯" value="消防员电梯" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="备注信息">
                      <el-input type="textarea" v-model="form.configReporRemark" :rows="3" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-row>

              <!-- level-3 检测项目表单 -->
              <el-row v-show="currentFormLevel === 3">
                <!-- 下面为检测项目类别相关的表单项，均为自定义字段，带中文注释 -->
                <el-col :span="12">
                  <!-- 检测项目类别 -->
                  <el-form-item label="检测项目类别">
                    <el-input v-model="form.configTestItemGroupName" placeholder="请输入检测项目类别" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 检测参数 -->
                  <el-form-item label="检测参数编码">
                    <el-input v-model="form.configTestItemCode" placeholder="请输入检测参数编码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 检测报告名称 -->
                  <el-form-item label="检测报告名称">
                    <el-input v-model="form.configReportName" placeholder="请输入检测报告名称" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="检测参数名称">
                    <el-input v-model="form.configTestItemName" placeholder="请输入检测参数名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 是否启用 -->
                  <el-form-item label="是否启用">
                    <el-switch v-model="form.enableState" :active-value="'1'" :inactive-value="'0'"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <!-- 是否默认 -->
                  <el-form-item label="是否默认">
                    <el-switch v-model="form.isDefault" :active-value="'1'" :inactive-value="'0'"></el-switch>
                  </el-form-item>
                </el-col>
                <!-- 所属机构 -->
                <!-- <el-col :span="12">
                <el-form-item label="所属机构">
                  <el-input v-model="form.tenantPid" placeholder="请输入所属机构"></el-input>
                </el-form-item>
              </el-col> -->
                <el-col :span="12">
                  <!-- 检测项目排序 -->
                  <el-form-item label="排序">
                    <el-input v-model="form.configTestItemIndex" placeholder="请输入检测项目排序"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <!-- 备注信息 -->
                  <el-form-item label="备注信息">
                    <el-input type="textarea" v-model="form.configTestItemRemark" :rows="2" placeholder="请输入备注信息"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- level-4 表单 -->
              <el-row v-show="currentFormLevel === 4">
                <!-- 第一部分：基础信息 -->
                <el-col :span="24">
                  <h4 style="margin-bottom: 20px; color: #409eff; border-bottom: 1px solid #eee; padding-bottom: 10px;">
                    <i class="el-icon-info"></i> 基础信息
                  </h4>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="检测参数子项">
                    <el-input v-model="form.configTestItemChildCode" placeholder="请输入检测参数"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="检测项子项名称">
                    <el-input v-model="form.configTestItemChildName" placeholder="请输入检测项子项名称"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="排序">
                    <el-input v-model="form.configTestItemChildIndex" placeholder="请输入排序"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否启用">
                    <el-switch v-model="form.enableState" :active-value="'1'" :inactive-value="'0'"></el-switch>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="是否默认">
                    <el-switch v-model="form.isDefault" :active-value="'1'" :inactive-value="'0'"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.configTestItemChildRemark" :rows="2" placeholder="请输入备注"></el-input>
                  </el-form-item>
                </el-col>

                <!-- 第二部分：检测项目内容描述 -->
                <el-col :span="24" style="margin-top: 30px;">
                  <h4 style="margin-bottom: 20px; color: #409eff; border-bottom: 1px solid #eee; padding-bottom: 10px;">
                    <i class="el-icon-document"></i> 检测项目内容描述
                  </h4>
                </el-col>

                <el-col :span="24">
                  <div style="margin-bottom: 10px; text-align: right;">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="addContentRow">
                      新增
                    </el-button>
                  </div>

                  <el-table :data="form.configTestItemsContentList" border style="width: 100%">
                    <!-- 父项一行：检测内容 + 新增子项 + 删除（同一行） -->
                    <el-table-column label="检测内容及子项" min-width="700">
                      <template slot-scope="scope">
                        <div class="content-header-row">
                          <el-input v-model="scope.row.configTestItemsContentDesc" placeholder="请输入检测内容" @input="handleContentChange(scope.$index, $event)" class="content-input"></el-input>
                          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addDetailRow(scope.$index)">
                            新增子项
                          </el-button>
                          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteContentRow(scope.$index)" :disabled="form.configTestItemsContentList.length <= 1">
                            删除
                          </el-button>
                        </div>

                        <!-- 子项列表：在父项下方展示 -->
                        <div class="detail-list detail-list-under">
                          <div v-if="!scope.row.detailList || scope.row.detailList.length === 0" class="detail-empty">
                            暂无子项，可点击“新增子项”快速添加
                          </div>
                          <div v-for="(detail, detailIndex) in scope.row.detailList" :key="detail.contentDetailPid || `${scope.$index}-${detailIndex}`" class="detail-row">
                            <span class="status-tag" :class="getDetailStatusClass(detail.checkResult)" @click="toggleDetailStatus(scope.$index, detailIndex)">
                              {{ getDetailStatusText(detail.checkResult) }}
                            </span>
                            <el-input v-model="detail.detailContent" placeholder="请输入子项内容" class="detail-input"></el-input>
                            <el-button type="text" class="detail-delete" @click="deleteDetailRow(scope.$index, detailIndex)">
                              删除
                            </el-button>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>

              <div class="action-buttons">
                <!-- 添加子级模式：显示保存按钮 -->
                <el-button v-if="operationMode === 'add'" type="primary" icon="el-icon-document-add" @click="handleSubmit">保存</el-button>

                <!-- 编辑模式：显示修改和删除按钮 -->
                <template v-if="operationMode === 'edit'">
                  <el-button type="warning" icon="el-icon-edit" @click="handleUpdate">修改</el-button>
                  <el-button type="danger" icon="el-icon-delete" @click="handleDelete" :disabled="hasChildren">删除</el-button>
                </template>

                <!-- 查看模式：不显示操作按钮或显示提示 -->
                <div v-if="operationMode === 'view'" class="view-tip">
                  <i class="el-icon-info"></i>
                  <span>请选择左侧树形结构中的节点进行操作</span>
                </div>
              </div>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增行业弹窗 -->
    <!-- <el-dialog title="新增行业" :visible.sync="industryDialogVisible" width="400px">
      <el-form ref="industryForm" :model="industryForm" :rules="industryRules" label-width="80px">
        <el-form-item label="行业编码" prop="code">
          <el-input v-model="industryForm.code" placeholder="请输入行业编码"></el-input>
        </el-form-item>
        <el-form-item label="行业名称" prop="name">
          <el-input v-model="industryForm.name" placeholder="请输入行业名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="industryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitIndustryForm">确 定</el-button>
      </div>
    </el-dialog> -->

    <!-- 新增种类弹窗 -->
    <!-- <el-dialog title="新增种类" :visible.sync="typeDialogVisible" width="400px">
      <el-form ref="typeForm" :model="typeForm" :rules="typeRules" label-width="80px">
        <el-form-item label="种类编码" prop="code">
          <el-input v-model="typeForm.code" placeholder="请输入种类编码"></el-input>
        </el-form-item>
        <el-form-item label="种类名称" prop="name">
          <el-input v-model="typeForm.name" placeholder="请输入种类名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTypeForm">确 定</el-button>
      </div>
    </el-dialog> -->

    <!-- 设备选择弹出层 -->
    <el-dialog title="选择设备" :visible.sync="deviceDialogVisible" width="800px" :close-on-click-modal="false">
      <div class="device-dialog-content">
        <!-- 搜索框 -->
        <div class="search-section" style="margin-bottom: 20px;">
          <el-input v-model="deviceSearchKeyword" placeholder="请输入设备名称或编号进行搜索" clearable @input="handleDeviceSearch" style="width: 300px;">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
        </div>

        <!-- 设备列表 -->
        <div class="device-list-section">
          <el-table ref="deviceTable" :data="filteredDeviceOptions" @selection-change="handleDeviceSelectionChange" height="400" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="eqptName" label="设备名称" min-width="100"></el-table-column>
            <el-table-column prop="eqptNum" label="设备编号" min-width="260"></el-table-column>
            <!-- <el-table-column prop="eqptModel" label="设备型号" width="150"></el-table-column> -->
            <!-- <el-table-column prop="eqptStatus" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.eqptStatus === '正常' ? 'success' : 'warning'">
                  {{ scope.row.eqptStatus || '正常' }}
                </el-tag>
              </template>
            </el-table-column> -->
          </el-table>
        </div>

        <!-- 已选设备统计 -->
        <div class="selected-count" style="margin-top: 15px; color: #606266;">
          已选择 {{ tempSelectedDevices.length }} 个设备
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDeviceSelection">取 消</el-button>
        <el-button type="primary" @click="confirmDeviceSelection">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 标准选择弹出层 -->
    <el-dialog title="选择标准" :visible.sync="standardDialogVisible" width="800px" :close-on-click-modal="false">
      <div class="standard-dialog-content">
        <!-- 搜索框 -->
        <div class="search-section" style="margin-bottom: 20px;">
          <el-input v-model="standardSearchKeyword" placeholder="请输入标准名称或编码进行搜索" clearable @input="handleStandardSearch" style="width: 300px;">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
        </div>

        <!-- 标准列表 -->
        <div class="standard-list-section">
          <el-table ref="standardTable" :data="filteredStandardOptions" @selection-change="handleStandardSelectionChange" height="400" style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="label" label="标准名称" min-width="260"></el-table-column>
            <el-table-column prop="standardCode" label="标准编码" min-width="200"></el-table-column>
          </el-table>
        </div>

        <!-- 已选标准统计 -->
        <div class="selected-count" style="margin-top: 15px; color: #606266;">
          已选择 {{ tempSelectedStandards.length }} 个标准
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelStandardSelection">取 消</el-button>
        <el-button type="primary" @click="confirmStandardSelection">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  templateQueryAllConfigReport, queryReportTypeDetail, queryConfigReportDetail, queryConfigTestItemDetail, queryConfigTestItemsChildDetail, queryConfigTestItemsContentDetail,
  saveReportType, saveConfigReport, saveConfigTestItems, saveConfigTestItemsChild, saveConfigTestItemsContent,
  updateReportType, updateConfigReport, updateConfigTestItems, updateConfigTestItemsChild, updateConfigTestItemsContent,
  deleteReportType,
  deleteConfigReport,
  deleteConfigTestItems,
  deleteConfigTestItemsChild,
  deleteContentByChildPid,
  queryAllTemplatePidAndName,
  queryAllStandardPidCodeName,
  queryEqptGuidAndName,
  querySysDepartments,
  queryAvailableJgEqpNames
} from '@/api/contract/contract'
export default {
  name: 'TestingIndex',
  data () {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      form: {
        // Level 1 - 类别相关字段
        reportTypeName: '',
        reportTypeIdx: '',

        // Level 2 - 检测报告相关字段
        configReportCode: '',
        configReportName: '',
        configReportSpecs1: '',
        configReportSpecs2: '',
        configReportSpecs3: '',
        configReportIndex: '',
        configReporRemark: '',
        jgEqpName: [],
        matchRecord: '',

        // Level 3 - 检测项目相关字段
        configTestItemGroupName: '',
        configTestItemCode: '',
        configTestItemName: '',
        configTestItemIndex: '',
        configTestItemRemark: '',

        // Level 4 - 检测项目子项字段
        configTestItemChildCode: '',
        configTestItemChildName: '',
        configTestItemChildRemark: '',
        configTestItemChildIndex: '',
        configTestItemsContentList: [
          { configTestItemsContentDesc: '', detailList: [] }
        ],

        // 通用字段
        enableState: '1',
        isDefault: '0',
        tenantPid: '',
        // 单选下拉对应的字符串字段
        templatePids: '', // 报告模板ID
        templateOriginalPids: '', // 原始记录模板ID
        // 多选下拉对应的数组字段（用于与输入输出字符串互转）
        standardPidList: [],
        eqptGuidList: []
      },
      // 操作模式：view-查看, edit-编辑, add-添加子级
      operationMode: 'view',
      // 是否正在添加子级
      isAddingChild: false,
      // 新增行业表单
      industryForm: {
        code: '',
        name: ''
      },
      // 新增种类表单
      typeForm: {
        code: '',
        name: ''
      },
      // 表单验证规则
      industryRules: {
        code: [
          { required: true, message: '请输入行业编码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入行业名称', trigger: 'blur' }
        ]
      },
      typeRules: {
        code: [
          { required: true, message: '请输入种类编码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入种类名称', trigger: 'blur' }
        ]
      },
      // 弹窗可见性
      industryDialogVisible: false,
      typeDialogVisible: false,
      // 当前操作的父节点
      currentParentNode: null,
      // 四个下拉框的选项数据（从接口加载）
      templateOptions: [], // [{ value: '模板ID', label: '模板名称' }]
      standardOptions: [], // [{ value: '标准ID', label: '标准名称(或编码)' }]
      eqptOptions: [],     // [{ value: '设备GUID', label: '设备名称' }]
      departmentOptions: [], // [{ value: '部门ID', label: '部门名称' }]
      jgEqpNameOptions: [], // [{ value: '监管设备名称', label: '监管设备名称' }]
      currentNode: null,
      projectName: '', // 项目搜索名称

      // 设备选择相关数据
      deviceDialogVisible: false, // 设备选择弹窗显示状态
      deviceSearchKeyword: '', // 设备搜索关键词
      selectedDevices: [], // 已选择的设备列表 [{ value: 'guid', label: '设备名称', eqptCode: '编号' }]
      tempSelectedDevices: [], // 弹窗中临时选择的设备列表
      filteredDeviceOptions: [], // 过滤后的设备选项

      // 标准选择相关数据
      standardDialogVisible: false, // 标准选择弹窗显示状态
      standardSearchKeyword: '', // 标准搜索关键词
      selectedStandards: [], // 已选择的标准列表 [{ value: 'standardPid', label: '标准名称' }]
      tempSelectedStandards: [], // 弹窗中临时选择的标准列表
      filteredStandardOptions: [], // 过滤后的标准选项
    }
  },
  computed: {
    // 判断当前节点是否有子数据
    hasChildren () {
      return this.currentNode && this.currentNode.children && this.currentNode.children.length > 0;
    },
    // 报告模板选项（templateType = 0）
    reportTemplateOptions () {
      return this.templateOptions.filter(opt => opt.templateType === '0' || opt.templateType === 0);
    },
    // 原始记录模板选项（templateType = 1）
    originalTemplateOptions () {
      return this.templateOptions.filter(opt => opt.templateType === '1' || opt.templateType === 1);
    },
    // 当前表单应该显示的级别
    currentFormLevel () {
      if (this.operationMode === 'add') {
        if (this.currentNode) {
          // 添加子级模式：显示下一级别的表单
          return (this.currentNode.level || 1) + 1;
        } else {
          // Level 1新增模式：没有父节点，显示第一级表单
          return 1;
        }
      } else if (this.operationMode === 'edit' && this.currentNode) {
        // 编辑模式：显示当前级别的表单
        return this.currentNode.level || 1;
      }
      return 1; // 默认显示第一级
    },
    // 已选设备的显示文本
    selectedDevicesDisplay () {
      if (this.selectedDevices.length === 0) {
        return '';
      }
      if (this.selectedDevices.length === 1) {
        return this.selectedDevices[0].label;
      }
      return `已选择 ${this.selectedDevices.length} 个设备`;
    },
    // 已选标准的显示文本
    selectedStandardsDisplay () {
      if (this.selectedStandards.length === 0) {
        return '';
      }
      if (this.selectedStandards.length === 1) {
        return this.selectedStandards[0].label;
      }
      return `已选择 ${this.selectedStandards.length} 个标准`;
    }
  },
  created () {
    this.loadTreeData();
    this.loadOptions();
    this.loadJgEqpNameOptions();
  },
  methods: {
    // 加载树数据
    loadTreeData () {
      templateQueryAllConfigReport().then(res => {
        // 在设置 treeData 之前，先为所有节点添加 parentId 字段
        this.treeData = this.processTreeData(res.additionalData, null);
      })
    },
    //禁止用户手动编辑输入框
    blurInput (event) {
      event.target.blur();
    },
    // 递归处理树数据，为每个节点添加 parentId 字段
    processTreeData (nodes, parentId) {
      if (!nodes || !Array.isArray(nodes)) return [];

      // 过滤掉后端异常返回的 level>4 节点，并补充 parentId
      return nodes.reduce((acc, node) => {
        const level = Number(node.level || 0);
        if (level > 4) {
          return acc;
        }

        const newNode = { ...node, parentId };

        if (node.children && node.children.length > 0) {
          newNode.children = this.processTreeData(node.children, node.id);
        }

        acc.push(newNode);
        return acc;
      }, []);
    },
    loadOptions () {
      // 加载三类下拉选项
      Promise.all([
        queryAllTemplatePidAndName(),
        queryAllStandardPidCodeName(),
        queryEqptGuidAndName({ eqptName: '' }),
        querySysDepartments({})
      ]).then(([tplRes, stdRes, eqptRes, deptRes]) => {
        console.log(tplRes, stdRes, eqptRes, deptRes)
        // 模板选项
        const tplList = (tplRes && tplRes.additionalData) ? tplRes.additionalData : [];
        this.templateOptions = (Array.isArray(tplList) ? tplList : []).map(i => ({
          value: i.templatePid || i.id || i.value,
          label: i.templateName || i.name || i.label,
          templateType: i.templateType || '' // 1-原始记录模板，0-报告模板
        }));

        // 标准选项
        const stdList = (stdRes && stdRes.additionalData) ? stdRes.additionalData : [];
        this.standardOptions = (Array.isArray(stdList) ? stdList : []).map(i => ({
          value: i.standardPid || i.id || i.value,
          label: i.standardName || i.name || i.codeName || i.label,
          standardCode: i.standardCode || i.code || ''
        }));

        // 设备选项 - 扩展字段以支持弹窗显示
        const eqList = (eqptRes && eqptRes.additionalData) ? eqptRes.additionalData : [];
        this.eqptOptions = (Array.isArray(eqList) ? eqList : []).map(i => ({
          value: i.eqptGuid || i.id || i.value,
          label: i.eqptName || i.name || i.label,
          eqptGuid: i.eqptGuid || i.code || '',
          eqptName: i.eqptName || i.name || i.label,
          eqptNum: i.eqptNum || i.code || ''
        }));

        // 部门选项
        const deptList = (deptRes && deptRes.additionalData) ? deptRes.additionalData : [];
        this.departmentOptions = (Array.isArray(deptList) ? deptList : []).map(i => ({
          value: i.tenantpid || i.id || i.value,
          label: i.departmentname || i.name || i.label
        }));


        // 初始化过滤后的设备选项
        this.filteredDeviceOptions = [...this.eqptOptions];

        // 初始化过滤后的标准选项
        this.filteredStandardOptions = [...this.standardOptions];


      }).catch(() => {
        this.$message.error('下拉选项加载失败');
      });
    },
    // 加载监管设备名称下拉选项
    async loadJgEqpNameOptions () {
      try {
        const res = await queryAvailableJgEqpNames();
        const source = (res && res.additionalData) ? res.additionalData : [];
        const list = Array.isArray(source) ? source : [];
        this.jgEqpNameOptions = list
          .map(item => {
            if (typeof item === 'string') {
              return { value: item, label: item };
            }
            const value = item.value || item.label || item.jgEqpName || item.name || item.eqpName || '';
            return value ? { value, label: value } : null;
          })
          .filter(Boolean);
      } catch (error) {
        this.jgEqpNameOptions = [];
        this.$message.error('监管设备名称加载失败');
      }
    },
    // 加载Level 1数据详情
    async loadLevel1Detail (reportTypePid) {
      try {
        const res = await queryReportTypeDetail({ reportTypePid });
        if (res && res.additionalData) {
          this.form.reportTypeName = res.additionalData.reportTypeName || '';
          this.form.reportTypeIdx = res.additionalData.reportTypeIdx || '';
          this.form.enableState = res.additionalData.enableState !== undefined ? res.additionalData.enableState : '1';
          this.form.tenantPid = res.additionalData.tenantPid || '';
        }
      } catch (error) {
        console.error('加载Level 1数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },
    // 加载Level 2数据详情
    async loadLevel2Detail (configReportPid) {
      try {
        const res = await queryConfigReportDetail({ configReportPid });
        if (res && res.additionalData) {
          this.form.configReportCode = res.additionalData.configReportCode || '';
          this.form.configReportName = res.additionalData.configReportName || '';
          this.form.configReportSpecs1 = res.additionalData.configReportSpecs1 || '';
          this.form.configReportSpecs2 = res.additionalData.configReportSpecs2 || '';
          this.form.configReportSpecs3 = res.additionalData.configReportSpecs3 || '';
          this.form.configReportIndex = res.additionalData.configReportIndex || '';
          this.form.configReporRemark = res.additionalData.configReporRemark || '';
          this.form.enableState = res.additionalData.enableState !== undefined ? res.additionalData.enableState : '1';
          this.form.tenantPid = res.additionalData.tenantPid || '';
          // 单选字段直接赋值
          this.form.templatePids = res.additionalData.templatePids[0] || '';
          this.form.templateOriginalPids = res.additionalData.templateOriginalPids[0] || '';
          // 多选字段：后端以逗号拼接字符串返回，需要解析为数组回填
          this.form.jgEqpName = res.additionalData.jgEqpName
            ? String(res.additionalData.jgEqpName)
              .split(',')
              .map(s => s.trim())
              .filter(Boolean)
            : [];
          this.form.matchRecord = res.additionalData.matchRecord || '';
          // 将字符串反填成数组（多选）
          this.form.standardPidList = res.additionalData.standardPids || (res.additionalData.standardPid ? String(res.additionalData.standardPid).split(',').filter(Boolean) : []);
          this.form.eqptGuidList = res.additionalData.equipmentGuids || (res.additionalData.eqptGuid ? String(res.additionalData.eqptGuid).split(',').filter(Boolean) : []);

          // 回填设备选择数据
          this.fillSelectedDevices(this.form.eqptGuidList);

          // 回填标准选择数据
          this.fillSelectedStandards(this.form.standardPidList);
        }
      } catch (error) {
        console.error('加载Level 2数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },
    // 加载Level 3数据详情
    async loadLevel3Detail (configTestItemPid) {
      try {
        const res = await queryConfigTestItemDetail({ configTestItemPid });
        if (res && res.additionalData) {
          this.form.configTestItemGroupName = res.additionalData.reportTypeName || '';
          this.form.configTestItemCode = res.additionalData.configTestItemCode || '';
          this.form.configReportName = res.additionalData.configReportName || '';
          this.form.configTestItemName = res.additionalData.configTestItemName || '';
          this.form.configTestItemIndex = res.additionalData.configTestItemIndex || '';
          this.form.configTestItemRemark = res.additionalData.configTestItemRemark || '';
          this.form.enableState = res.additionalData.enableState || '1';
          this.form.isDefault = res.additionalData.isDefault || '0';
          this.form.tenantPid = res.additionalData.tenantPid || '';
        }
        console.log(this.form);
      } catch (error) {
        console.error('加载Level 3数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },
    // 加载Level 4数据详情
    async loadLevel4Detail (configTestItemChildPid) {
      try {
        // 并行请求两个接口
        // 注意：两个接口都使用Level 4自身的ID，但参数名不同
        const [childRes, contentRes] = await Promise.all([
          queryConfigTestItemsChildDetail({ configTestItemChildPid }),
          queryConfigTestItemsContentDetail({ configTestItemChildPid })
        ]);

        // 处理基础信息
        if (childRes && childRes.additionalData) {
          this.form.configTestItemChildCode = childRes.additionalData.configTestItemChildCode || '';
          this.form.configTestItemChildName = childRes.additionalData.configTestItemChildName || '';
          this.form.configTestItemChildRemark = childRes.additionalData.configTestItemChildRemark || '';
          this.form.configTestItemChildIndex = childRes.additionalData.configTestItemChildIndex || '';
          this.form.enableState = childRes.additionalData.enableState !== undefined ? childRes.additionalData.enableState : '1';
          this.form.isDefault = childRes.additionalData.isDefault !== undefined ? childRes.additionalData.isDefault : '0';
          this.form.tenantPid = childRes.additionalData.tenantPid || '';
        }

        // 将内容列表填充到表格（优先数组，兼容对象或空）
        let list = [];
        if (contentRes && contentRes.additionalData) {
          const data = contentRes.additionalData;
          if (Array.isArray(data)) {
            list = data.map(d => ({
              configTestItemsContentDesc: (d.configTestItemsContentDesc || '').trim(),
              configTestItemsContentCode: d.configTestItemsContentCode || '',
              configTestItemsContentPid: d.configTestItemsContentPid || '',
              configTestItemContentIndex: d.configTestItemContentIndex || d.configTestItemsContentIndex || '',
              detailList: (d.detailList || []).map(item => ({
                checkResult: item.checkResult !== undefined ? item.checkResult : 1,
                configTestItemsContentCode: item.configTestItemsContentCode || d.configTestItemsContentCode || '',
                configTestItemsContentPid: item.configTestItemsContentPid || d.configTestItemsContentPid || '',
                contentDetailPid: item.contentDetailPid || '',
                detailContent: item.detailContent || '',
                detailIndex: item.detailIndex || ''
              }))
            }));
          } else if (data && typeof data === 'object' && data.configTestItemsContentDesc !== undefined) {
            list = [{
              configTestItemsContentDesc: (data.configTestItemsContentDesc || '').trim(),
              configTestItemsContentCode: data.configTestItemsContentCode || '',
              configTestItemsContentPid: data.configTestItemsContentPid || '',
              configTestItemContentIndex: data.configTestItemContentIndex || data.configTestItemsContentIndex || '',
              detailList: (data.detailList || []).map(item => ({
                checkResult: item.checkResult !== undefined ? item.checkResult : 1,
                configTestItemsContentCode: item.configTestItemsContentCode || data.configTestItemsContentCode || '',
                configTestItemsContentPid: item.configTestItemsContentPid || data.configTestItemsContentPid || '',
                contentDetailPid: item.contentDetailPid || '',
                detailContent: item.detailContent || '',
                detailIndex: item.detailIndex || ''
              }))
            }];
          }
        }
        if (!list.length) list = [{ configTestItemsContentDesc: '', detailList: [] }];
        this.$set(this.form, 'configTestItemsContentList', list);
      } catch (error) {
        console.error('加载Level 4数据失败:', error);
        this.$message.error('加载数据失败');
      }
    },
    // 筛选节点
    filterTreeNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 过滤树节点
    filterTree () {
      this.$refs.projectTree.filter(this.projectName);
    },
    // 节点单击事件 - 设置为编辑模式
    handleNodeClick (data) {
      this.currentNode = data;
      this.operationMode = 'edit';
      this.isAddingChild = false;
      this.loadJgEqpNameOptions();

      // 根据节点level调用对应的数据加载接口
      if (data.level === 1) {
        this.loadLevel1Detail(data.id);
      } else if (data.level === 2) {
        this.loadLevel2Detail(data.id);
      } else if (data.level === 3) {
        this.loadLevel3Detail(data.id);
      } else if (data.level === 4) {
        // Level 4需要两个ID参数：基础信息用自身ID，内容描述也用自身ID
        this.loadLevel4Detail(data.id);
      } else {
        // 兼容旧的逻辑
        if (data.type === 'project') {
          this.loadProjectDetail(data.id)
        } else {
          this.loadNodeDetail(data);
        }
      }
    },
    loadProjectDetail (projectId) {
      const mockProject = {
        id: projectId,
        projectCode: `PJ-${projectId}`,
        projectName: `项目-${projectId}`,
        spec1: 'Spec1-示例值',
        spec2: 'Spec2-示例值',
        spec3: 'Spec3-示例值',
        standardId: 1,
        deviceId: 2,
        templateId: 1,
        remark: '这是一个示例备注信息，包含项目详细说明和注意事项。'
      }
      this.form = { ...mockProject }
    },
    // 加载节点详情
    loadNodeDetail (node) {
      // 清空表单
      this.handleClearForm();

      // 根据节点level加载对应的数据到表单
      if (node.level === 1) {
        this.form.reportTypeName = node.name || '';
        this.form.reportTypeIdx = node.index || '';
      } else if (node.level === 2) {
        this.form.configReportCode = node.code || '';
        this.form.configReportName = node.name || '';
        this.form.configReportSpecs1 = node.specs1 || '';
        this.form.configReportSpecs2 = node.specs2 || '';
        this.form.configReportSpecs3 = node.specs3 || '';
        this.form.configReportIndex = node.index || '';
        this.form.configReporRemark = node.remark || '';
      } else if (node.level === 3) {
        this.form.configTestItemGroupName = node.groupName || '';
        this.form.configTestItemCode = node.code || '';
        this.form.configTestItemName = node.name || '';
        this.form.configTestItemIndex = node.index || '';
        this.form.configTestItemRemark = node.remark || '';
      } else if (node.level === 4) {
        this.form.configTestItemChildCode = node.configTestItemChildCode || '';
        this.form.configTestItemChildName = node.configTestItemChildName || '';
        this.form.configTestItemChildRemark = node.configTestItemChildRemark || '';
        this.form.configTestItemChildIndex = node.configTestItemChildIndex || '';
        this.form.configTestItemsContentDesc = node.configTestItemsContentDesc || '';
      }

      // 通用字段
      this.form.enableState = node.enableState !== undefined ? node.enableState : '1';
      this.form.isDefault = node.isDefault !== undefined ? node.isDefault : '0';
      this.form.tenantPid = node.tenantPid || '';
    },
    handleClearForm () {
      this.form = {
        // Level 1 - 类别相关字段
        reportTypeName: '',
        reportTypeIdx: '',

        // Level 2 - 检测报告相关字段
        configReportCode: '',
        configReportName: '',
        configReportSpecs1: '',
        configReportSpecs2: '',
        configReportSpecs3: '',
        configReportIndex: '',
        configReporRemark: '',
        jgEqpName: [],
        matchRecord: '',
        // Level 3 - 检测项目相关字段
        configTestItemGroupName: '',
        configTestItemCode: '',
        configTestItemName: '',
        configTestItemIndex: '',
        configTestItemRemark: '',

        // Level 4 - 检测项目子项字段
        configTestItemChildCode: '',
        configTestItemChildName: '',
        configTestItemChildRemark: '',
        configTestItemChildIndex: '',
        configTestItemsContentList: [
          { configTestItemsContentDesc: '' }
        ],

        // 通用字段
        enableState: '1',
        isDefault: '0',
        tenantPid: '',
        // 单选字段重置为空字符串
        templatePids: '',
        templateOriginalPids: '',
        // 多选字段重置为空数组
        standardPidList: [],
        eqptGuidList: []
      }

      // 清空设备选择数据
      this.selectedDevices = [];

      // 清空标准选择数据
      this.selectedStandards = [];
    },
    async handleSubmit () {
      if (this.operationMode === 'add') {
        const level = this.currentFormLevel;

        // 基础验证
        if (!this.validateForm(level)) {
          return;
        }

        // 根据级别调用不同的保存方法
        if (level === 1) {
          // Level 1：新增报告类别，无需父级ID
          await this.saveLevel1Data();
        } else if (level === 2) {
          // Level 2：新增检测报告，需要reportTypePid
          const parentId = this.currentParentNode?.id;
          if (!parentId) {
            this.$message.error('缺少上级ID');
            return;
          }
          await this.saveLevel2Data(parentId);
        } else if (level === 3) {
          // Level 3：新增检测项目，需要configReportPid
          const parentId = this.currentParentNode?.id;
          if (!parentId) {
            this.$message.error('缺少上级ID');
            return;
          }
          await this.saveLevel3Data(parentId);
        } else if (level === 4) {
          // Level 4：新增检测项目子项，需要configTestItemPid
          const parentId = this.currentParentNode?.id;
          if (!parentId) {
            this.$message.error('缺少上级ID');
            return;
          }
          await this.saveLevel4Data(parentId);
        }
      } else {
        this.$message.success('保存成功！数据为：' + JSON.stringify(this.form))
        // 实际开发中调用 API 提交 this.form
      }
    },
    // 表单验证
    validateForm (level) {
      if (level === 1) {
        if (!this.form.reportTypeName.trim()) {
          this.$message.error('请输入类别名称');
          return false;
        }
      } else if (level === 2) {
        if (!this.form.configReportName.trim()) {
          this.$message.error('请输入检测报告名称');
          return false;
        }
        if (!Array.isArray(this.form.jgEqpName) || this.form.jgEqpName.length === 0) {
          this.$message.error('请选择监管设备名称');
          return false;
        }
        if (!this.form.matchRecord.trim()) {
          this.$message.error('请选择');
          return false;
        }
      } else if (level === 3) {
        if (!this.form.configTestItemName.trim()) {
          this.$message.error('请输入检测项目名称');
          return false;
        }
      } else if (level === 4) {
        if (!this.form.configTestItemChildName.trim()) {
          this.$message.error('请输入检测项目名称');
          return false;
        }
        if (!this.form.configTestItemChildCode.trim()) {
          this.$message.error('请输入检测项目编号');
          return false;
        }
        const hasValid = (this.form.configTestItemsContentList || []).some(i => (i.configTestItemsContentDesc || '').trim());
        if (!hasValid) {
          this.$message.error('请至少填写一条检测内容');
          return false;
        }
      }
      return true;
    },
    // 新增内容行
    addContentRow () {
      this.form.configTestItemsContentList.push({
        configTestItemsContentDesc: '',
        detailList: []
      });
    },
    // 删除内容行
    deleteContentRow (index) {
      if (this.form.configTestItemsContentList.length > 1) {
        this.form.configTestItemsContentList.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行数据');
      }
    },
    // 处理内容变化
    handleContentChange (index, value) {
      this.form.configTestItemsContentList[index].configTestItemsContentDesc = value;
    },
    // 新增子项行
    addDetailRow (contentIndex) {
      const contentItem = this.form.configTestItemsContentList[contentIndex];
      if (!contentItem.detailList) {
        this.$set(contentItem, 'detailList', []);
      }
      const nextIndex = (contentItem.detailList.length || 0) + 1;
      contentItem.detailList.push({
        checkResult: 1, // 默认符合
        configTestItemsContentCode: contentItem.configTestItemsContentCode || '',
        configTestItemsContentPid: contentItem.configTestItemsContentPid || '',
        contentDetailPid: '',
        detailContent: '',
        detailIndex: nextIndex
      });
    },
    // 删除子项行
    deleteDetailRow (contentIndex, detailIndex) {
      const contentItem = this.form.configTestItemsContentList[contentIndex];
      if (!contentItem || !contentItem.detailList) return;
      contentItem.detailList.splice(detailIndex, 1);
    },
    // 状态轮播切换：1(符合) -> 0(不符合) -> -1(无此项)
    toggleDetailStatus (contentIndex, detailIndex) {
      const contentItem = this.form.configTestItemsContentList[contentIndex];
      if (!contentItem || !contentItem.detailList || !contentItem.detailList[detailIndex]) return;
      const order = [1, 0, -1];
      const current = Number(contentItem.detailList[detailIndex].checkResult);
      const next = order[(order.indexOf(current) + 1) % order.length];
      this.$set(contentItem.detailList[detailIndex], 'checkResult', next);
    },
    // 状态显示文本
    getDetailStatusText (status) {
      const map = {
        1: '符合',
        0: '不符合',
        '-1': '无此项'
      };
      return map[status] || '符合';
    },
    // 状态样式类
    getDetailStatusClass (status) {
      if (status === 1 || status === '1') return 'status-ok';
      if (status === 0 || status === '0') return 'status-fail';
      return 'status-none';
    },
    // 保存Level 1数据
    async saveLevel1Data () {
      try {
        const data = {
          reportTypeName: this.form.reportTypeName,
          reportTypeIdx: this.form.reportTypeIdx,
          enableState: this.form.enableState,
          tenantPid: this.form.tenantPid
        };

        const res = await saveReportType(data);
        if (res && res.retCode === 'ok') {
          this.$message.success('新增报告类别成功！');
          this.loadTreeData(); // 重新加载树数据
          this.operationMode = 'view';
          this.currentNode = null;
          this.handleClearForm();
          return true;
        } else {
          this.$message.error(res.message || '新增失败');
          return false;
        }
      } catch (error) {
        console.error('保存Level 1数据失败:', error);
        this.$message.error('保存失败');
        return false;
      }
    },
    // 保存Level 2数据
    async saveLevel2Data (reportTypePid) {
      try {
        // 后端入参期望字符串：多选值用英文逗号拼接
        const jgEqpNameString = Array.isArray(this.form.jgEqpName)
          ? this.form.jgEqpName.join(',')
          : (this.form.jgEqpName ? String(this.form.jgEqpName) : '')
        const data = {
          reportTypePid: reportTypePid,
          configReportCode: this.form.configReportCode,
          configReportName: this.form.configReportName,
          configReportSpecs1: this.form.configReportSpecs1,
          configReportSpecs2: this.form.configReportSpecs2,
          configReportSpecs3: this.form.configReportSpecs3,
          configReportIndex: this.form.configReportIndex,
          configReporRemark: this.form.configReporRemark,
          enableState: this.form.enableState,
          tenantPid: this.form.tenantPid,
          // 单选字段直接提交
          templatePids: [this.form.templatePids],
          templateOriginalPids: [this.form.templateOriginalPids],
          jgEqpName: jgEqpNameString,
          matchRecord: this.form.matchRecord,
          standardPids: this.form.standardPidList,
          equipmentGuids: this.form.eqptGuidList
        };

        const res = await saveConfigReport(data);
        if (res && res.retCode === 'ok') {
          this.$message.success('新增检测报告成功！');
          this.loadTreeData(); // 重新加载树数据
          this.operationMode = 'view';
          this.currentNode = null;
          this.handleClearForm();
          return true;
        } else {
          this.$message.error(res.message || '新增失败');
          return false;
        }
      } catch (error) {
        console.error('保存Level 2数据失败:', error);
        this.$message.error('保存失败');
        return false;
      }
    },
    // 保存Level 3数据
    async saveLevel3Data (configReportPid) {
      try {
        const data = {
          configReportPid: configReportPid,
          configTestItemGroupName: this.form.configTestItemGroupName,
          configTestItemCode: this.form.configTestItemCode,
          configTestItemName: this.form.configTestItemName,
          configTestItemIndex: this.form.configTestItemIndex,
          configTestItemRemark: this.form.configTestItemRemark,
          enableState: this.form.enableState,
          isDefault: this.form.isDefault,
          tenantPid: this.form.tenantPid
        };

        const res = await saveConfigTestItems(data);
        if (res && res.retCode === 'ok') {
          this.$message.success('新增检测项目成功！');
          this.loadTreeData(); // 重新加载树数据
          this.operationMode = 'view';
          this.currentNode = null;
          this.handleClearForm();
          return true;
        } else {
          this.$message.error(res.message || '新增失败');
          return false;
        }
      } catch (error) {
        console.error('保存Level 3数据失败:', error);
        this.$message.error('保存失败');
        return false;
      }
    },
    // 保存Level 4数据（双接口）
    async saveLevel4Data (configTestItemPid) {
      try {
        // 第一步：保存基础信息
        const childData = {
          configTestItemPid: configTestItemPid,
          configTestItemChildCode: this.form.configTestItemChildCode,
          configTestItemChildName: this.form.configTestItemChildName,
          configTestItemChildRemark: this.form.configTestItemChildRemark,
          configTestItemChildIndex: this.form.configTestItemChildIndex,
          enableState: this.form.enableState,
          isDefault: this.form.isDefault,
          tenantPid: this.form.tenantPid,
          contentList: this.form.configTestItemsContentList.map(item => ({
            configTestItemsContentDesc: item.configTestItemsContentDesc,
            configTestItemsContentCode: item.configTestItemsContentCode || '',
            configTestItemsContentPid: item.configTestItemsContentPid || '',
            configTestItemContentIndex: item.configTestItemContentIndex || item.configTestItemsContentIndex || '',
            detailList: (item.detailList || []).map(detail => ({
              checkResult: detail.checkResult !== undefined ? detail.checkResult : 1,
              configTestItemsContentCode: detail.configTestItemsContentCode || item.configTestItemsContentCode || '',
              configTestItemsContentPid: detail.configTestItemsContentPid || item.configTestItemsContentPid || '',
              contentDetailPid: detail.contentDetailPid || '',
              detailContent: detail.detailContent || '',
              detailIndex: detail.detailIndex || ''
            }))
          }))
        };

        const childRes = await saveConfigTestItemsChild(childData);
        if (!childRes || !childRes.retCode === 'ok') {
          this.$message.error(childRes.message || '保存基础信息失败');
          return false;
        }

        this.$message.success('新增检测项目子项成功！');
        this.loadTreeData(); // 重新加载树数据
        this.operationMode = 'view';
        this.currentNode = null;
        this.handleClearForm();
        return true;

      } catch (error) {
        console.error('保存Level 4数据失败:', error);
        this.$message.error('保存失败');
        return false;
      }
    },
    // 根据当前表单数据创建新节点
    createNewNode () {
      const level = this.currentFormLevel;
      const newNode = {
        id: Date.now(),
        level: level,
        enableState: this.form.enableState,
        isDefault: this.form.isDefault,
        tenantPid: this.form.tenantPid,
        children: []
      };

      if (level === 1) {
        newNode.name = this.form.reportTypeName;
        newNode.index = this.form.reportTypeIdx;
        newNode.type = 'category';
      } else if (level === 2) {
        newNode.name = this.form.configReportName;
        newNode.code = this.form.configReportCode;
        newNode.specs1 = this.form.configReportSpecs1;
        newNode.specs2 = this.form.configReportSpecs2;
        newNode.specs3 = this.form.configReportSpecs3;
        newNode.index = this.form.configReportIndex;
        newNode.remark = this.form.configReporRemark;
        newNode.type = 'industry';
      } else if (level === 3) {
        newNode.name = this.form.configTestItemName;
        newNode.code = this.form.configTestItemCode;
        newNode.groupName = this.form.configTestItemGroupName;
        newNode.index = this.form.configTestItemIndex;
        newNode.remark = this.form.configTestItemRemark;
        newNode.type = 'type';
      } else if (level === 4) {
        newNode.name = this.form.configTestItemChildName;
        newNode.configTestItemChildCode = this.form.configTestItemChildCode;
        newNode.configTestItemChildName = this.form.configTestItemChildName;
        newNode.configTestItemChildRemark = this.form.configTestItemChildRemark;
        newNode.configTestItemChildIndex = this.form.configTestItemChildIndex;
        newNode.configTestItemsContentDesc = this.form.configTestItemsContentDesc;
        newNode.type = 'project';
      }

      return newNode;
    },
    handleUpdate () {
      // 根据当前节点的level选择不同的更新接口
      if (!this.currentNode) return;
      const level = this.currentNode.level;

      if (level === 1) {
        const payload = {
          reportTypePid: this.currentNode.id,
          reportTypeName: this.form.reportTypeName,
          reportTypeIdx: this.form.reportTypeIdx,
          enableState: this.form.enableState,
          tenantPid: this.form.tenantPid
        };
        updateReportType(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('修改成功！');
            this.loadTreeData();
          }
        });
      } else if (level === 2) {
        const jgEqpNameString = Array.isArray(this.form.jgEqpName)
          ? this.form.jgEqpName.join(',')
          : (this.form.jgEqpName ? String(this.form.jgEqpName) : '')
        const payload = {
          configReportPid: this.currentNode.id,
          reportTypePid: this.currentNode.parentId,
          configReportCode: this.form.configReportCode,
          configReportName: this.form.configReportName,
          configReportSpecs1: this.form.configReportSpecs1,
          configReportSpecs2: this.form.configReportSpecs2,
          configReportSpecs3: this.form.configReportSpecs3,
          configReportIndex: this.form.configReportIndex,
          configReporRemark: this.form.configReporRemark,
          enableState: this.form.enableState,
          tenantPid: this.form.tenantPid,
          // 单选字段直接提交
          templatePids: [this.form.templatePids],
          templateOriginalPids: [this.form.templateOriginalPids],
          jgEqpName: jgEqpNameString,
          matchRecord: this.form.matchRecord,
          // 多选数组转字符串提交
          standardPids: this.form.standardPidList,
          equipmentGuids: this.form.eqptGuidList
        };
        updateConfigReport(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('修改成功！');
            this.loadTreeData();
          } else {
            this.$message.error('修改失败！');
          }
        });
      } else if (level === 3) {
        const payload = {
          configTestItemPid: this.currentNode.id,
          configReportPid: this.currentNode.parentId, //获取父节点的id
          configTestItemGroupName: this.form.configTestItemGroupName,
          configTestItemCode: this.form.configTestItemCode,
          configTestItemName: this.form.configTestItemName,
          configTestItemIndex: this.form.configTestItemIndex,
          configTestItemRemark: this.form.configTestItemRemark,
          enableState: this.form.enableState,
          isDefault: this.form.isDefault,
          tenantPid: this.form.tenantPid
        };
        updateConfigTestItems(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('修改成功！');
            this.loadTreeData();
          } else {
            this.$message.error('修改失败！');
          }
        });
      } else if (level === 4) {
        const payload = {
          configTestItemChildPid: this.currentNode.id,
          configTestItemPid: this.currentNode.parentId,//获取父节点的id
          configTestItemChildCode: this.form.configTestItemChildCode,
          configTestItemChildName: this.form.configTestItemChildName,
          configTestItemChildRemark: this.form.configTestItemChildRemark,
          configTestItemChildIndex: this.form.configTestItemChildIndex,
          enableState: this.form.enableState,
          isDefault: this.form.isDefault,
          tenantPid: this.form.tenantPid,
          contentList: (this.form.configTestItemsContentList || [])
            .filter(i => (i.configTestItemsContentDesc || '').trim())
            .map(i => ({
              configTestItemsContentDesc: i.configTestItemsContentDesc.trim(),
              configTestItemsContentCode: i.configTestItemsContentCode || '',
              configTestItemsContentPid: i.configTestItemsContentPid || '',
              configTestItemContentIndex: i.configTestItemContentIndex || i.configTestItemsContentIndex || '',
              detailList: (i.detailList || []).map(detail => ({
                checkResult: detail.checkResult !== undefined ? detail.checkResult : 1,
                configTestItemsContentCode: detail.configTestItemsContentCode || i.configTestItemsContentCode || '',
                configTestItemsContentPid: detail.configTestItemsContentPid || i.configTestItemsContentPid || '',
                contentDetailPid: detail.contentDetailPid || '',
                detailContent: detail.detailContent || '',
                detailIndex: detail.detailIndex || ''
              }))
            }))
        };
        updateConfigTestItemsChild(payload).then(res => {
          if (res && res.retCode === 'ok') {
            this.$message.success('修改成功！');
            this.loadTreeData();
          } else {
            this.$message.error('修改失败！');
          }
        });
      }
    },
    handleDelete () {
      if (!this.currentNode) return;
      const level = this.currentNode.level;
      const nodeType = this.getNodeTypeName(this.currentNode.type);
      this.$confirm(`确定要删除该${nodeType}吗？`, '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          let res = null;
          if (level === 1) {
            res = await deleteReportType({ reportTypePid: this.currentNode.id });
          } else if (level === 2) {
            res = await deleteConfigReport({ configReportPid: this.currentNode.id });
          } else if (level === 3) {
            res = await deleteConfigTestItems({ configTestItemPid: this.currentNode.id });
          } else if (level === 4) {
            // Level 4 需要调用两个删除接口
            try {
              // 先删除内容描述
              await deleteContentByChildPid({ configTestItemChildPid: this.currentNode.id });
              // 再删除基础信息
              res = await deleteConfigTestItemsChild({ configTestItemChildPid: this.currentNode.id });
            } catch (error) {
              this.$message.error('删除失败');
              return;
            }
          }
          if (res && res.retCode === 'ok') {
            this.$message.success('删除成功');
            this.loadTreeData();
            this.currentNode = null;
            this.operationMode = 'view';
            this.handleClearForm();
          } else {
            this.$message.error(res?.message || '删除失败');
          }
        } catch (e) {
          console.error('删除失败:', e);
          this.$message.error('删除失败');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    handleDeleteNode (node) {
      const nodeType = this.getNodeTypeName(node.type);
      this.$confirm(`确定要删除该${nodeType}及其所有子项吗？`, '删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 树节点删除：根据 level 调用对应删除接口
          let res = null;
          if (node.level === 1) {
            res = await deleteReportType({ reportTypePid: node.id });
          } else if (node.level === 2) {
            res = await deleteConfigReport({ configReportPid: node.id });
          } else if (node.level === 3) {
            res = await deleteConfigTestItems({ configTestItemPid: node.id });
          } else if (node.level === 4) {
            // Level 4 需要调用两个删除接口
            try {
              // 先删除内容描述
              await deleteContentByChildPid({ configTestItemChildPid: node.id });
              // 再删除基础信息
              res = await deleteConfigTestItemsChild({ configTestItemChildPid: node.id });
            } catch (error) {
              this.$message.error('删除失败');
              return;
            }
          }
          if (res && res.retCode === 'ok') {
            this.$message.warning(`${nodeType}已删除`);
            this.loadTreeData();
            if (this.currentNode && this.currentNode.id === node.id) {
              this.currentNode = null;
              this.operationMode = 'view';
              this.handleClearForm();
            }
          } else {
            this.$message.error(res?.message || '删除失败');
          }
        } catch (e) {
          console.error('删除失败:', e);
          this.$message.error('删除失败');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 新增按钮统一处理方法
    handleAdd () {
      if (!this.currentNode) {
        // 没有选中节点，新增Level 1项目
        this.handleAddLevel1();
      } else {
        // 选中了节点，在该节点下新增子级
        this.handleAddChild(this.currentNode);
      }
    },
    // 新增Level 1报告类别
    handleAddLevel1 () {
      this.currentNode = null; // Level 1没有父节点
      this.operationMode = 'add';
      this.isAddingChild = false;
      this.currentParentNode = null;

      // 清空表单，准备添加新数据
      this.handleClearForm();

      // 设置默认值
      this.form.reportTypeName = '';
      this.form.reportTypeIdx = '';
    },
    // 添加子级节点 - 设置为添加模式
    handleAddChild (parent) {
      this.currentNode = parent;
      this.operationMode = 'add';
      this.isAddingChild = true;
      this.currentParentNode = parent;

      // 清空表单，准备添加新数据
      this.handleClearForm();

      // 根据父节点level，预设下一级的默认值
      const nextLevel = (parent.level || 1) + 1;
      if (nextLevel === 1) {
        // this.form.reportTypeName = '新类别';
      } else if (nextLevel === 2) {
        // this.form.configReportName = '新检测报告';
      } else if (nextLevel === 3) {
        // this.form.configTestItemName = '新检测项目';
        // Level 3 需要设置默认值：configTestItemGroupName为Level 1的name，configTestItemName为Level 2的name
        const level1Name = this.findLevel1Name(parent);
        const level2Name = parent.name; // 当前父节点就是Level 2
        this.form.configTestItemGroupName = level1Name || '';
        this.form.configReportName = level2Name || '';
      } else if (nextLevel === 4) {
        // this.form.configTestItemChildName = '新检测项目子项';
        // Level 4 需要设置默认值：configTestItemChildCode为父节点的name
        // this.form.configTestItemChildCode = parent.name || '';
      }
    },
    // 查找Level 1节点的名称
    findLevel1Name (node) {
      // 如果当前节点就是Level 1，返回其名称
      if (node.level === 1) {
        return node.name;
      }

      // 通过parentId向上查找Level 1节点
      const findNodeById = (nodes, id) => {
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].id === id) {
            return nodes[i];
          }
          if (nodes[i].children && nodes[i].children.length > 0) {
            const found = findNodeById(nodes[i].children, id);
            if (found) return found;
          }
        }
        return null;
      };

      let currentNode = node;
      while (currentNode && currentNode.parentId) {
        const parentNode = findNodeById(this.treeData, currentNode.parentId);
        if (parentNode) {
          if (parentNode.level === 1) {
            return parentNode.name;
          }
          currentNode = parentNode;
        } else {
          break;
        }
      }

      return '';
    },
    submitIndustryForm () {
      this.$refs.industryForm.validate((valid) => {
        if (valid) {
          const newIndustry = {
            id: Date.now(),
            name: this.industryForm.name,
            code: this.industryForm.code,
            type: 'industry',
            children: []
          };

          const parentNode = this.currentParentNode;
          if (!parentNode.children) {
            this.$set(parentNode, 'children', []);
          }

          parentNode.children.push(newIndustry);
          this.industryDialogVisible = false; // 关闭弹窗
          this.$message.success('新增行业成功');
        }
      });
    },
    handleAddType (parent) {
      if (!parent) {
        this.$message.warning('请先在树形结构中选择一个行业');
        return;
      }

      this.currentParentNode = parent;
      this.typeForm = { code: '', name: '' }; // 重置表单
      this.typeDialogVisible = true; // 显示弹窗
    },
    submitTypeForm () {
      this.$refs.typeForm.validate((valid) => {
        if (valid) {
          const newType = {
            id: Date.now(),
            name: this.typeForm.name,
            code: this.typeForm.code,
            type: 'type',
            children: []
          };

          const parentNode = this.currentParentNode;
          if (!parentNode.children) {
            this.$set(parentNode, 'children', []);
          }

          parentNode.children.push(newType);
          this.typeDialogVisible = false; // 关闭弹窗
          this.$message.success('新增种类成功');
        }
      });
    },
    handleAddProject (parent) {
      if (!parent) {
        this.$message.warning('请先在树形结构中选择一个种类');
        return;
      }

      this.$prompt('请输入新项目名称', '新增项目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        const newProject = {
          id: Date.now(),
          name: value,
          type: 'project'
        };

        if (!parent.children) {
          this.$set(parent, 'children', []);
        }

        parent.children.push(newProject);
        this.$message.success('新增项目成功');
      }).catch(() => {
        this.$message.info('取消新增');
      });
    },
    getNodeTypeName (type) {
      const map = {
        'category': '分类',
        'industry': '行业',
        'type': '种类',
        'project': '项目'
      };
      return map[type] || '节点';
    },
    getNodeIcon (type) {
      const map = {
        'category': 'el-icon-folder',
        'industry': 'el-icon-office-building',
        'type': 'el-icon-collection',
        'project': 'el-icon-tickets'
      };
      return map[type] || 'el-icon-circle';
    },

    // ============ 设备选择相关方法 ============

    // 打开设备选择弹窗
    getAllengineeringName () {
      this.deviceDialogVisible = true;
      this.deviceSearchKeyword = '';
      this.filteredDeviceOptions = [...this.eqptOptions];

      // 设置临时选择列表为当前已选择的设备
      this.tempSelectedDevices = [...this.selectedDevices];

      // 等待DOM更新后设置表格选中状态
      this.$nextTick(() => {
        if (this.$refs.deviceTable) {
          // 清空之前的选择
          this.$refs.deviceTable.clearSelection();

          // 设置已选择的设备为选中状态
          this.selectedDevices.forEach(selectedDevice => {
            const row = this.filteredDeviceOptions.find(option => option.value === selectedDevice.value);
            if (row) {
              this.$refs.deviceTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },

    // 设备搜索
    handleDeviceSearch () {
      const keyword = this.deviceSearchKeyword.toLowerCase();
      if (!keyword) {
        this.filteredDeviceOptions = [...this.eqptOptions];
      } else {
        this.filteredDeviceOptions = this.eqptOptions.filter(device =>
          (device.eqptName && device.eqptName.toLowerCase().includes(keyword)) ||
          (device.eqptCode && device.eqptCode.toLowerCase().includes(keyword)) ||
          (device.label && device.label.toLowerCase().includes(keyword))
        );
      }

      // 重新设置表格选中状态
      this.$nextTick(() => {
        if (this.$refs.deviceTable) {
          this.$refs.deviceTable.clearSelection();
          this.tempSelectedDevices.forEach(selectedDevice => {
            const row = this.filteredDeviceOptions.find(option => option.value === selectedDevice.value);
            if (row) {
              this.$refs.deviceTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },

    // 设备选择变化
    handleDeviceSelectionChange (selection) {
      this.tempSelectedDevices = selection.map(device => ({
        value: device.value,
        label: device.label,
        eqptCode: device.eqptCode,
        eqptName: device.eqptName
      }));
    },

    // 确认设备选择
    confirmDeviceSelection () {
      this.selectedDevices = [...this.tempSelectedDevices];

      // 更新 form.eqptGuidList 以保持数据格式一致
      this.form.eqptGuidList = this.selectedDevices.map(device => device.value);

      this.deviceDialogVisible = false;
      this.$message.success(`已选择 ${this.selectedDevices.length} 个设备`);
    },

    // 取消设备选择
    cancelDeviceSelection () {
      this.tempSelectedDevices = [];
      this.deviceDialogVisible = false;
    },

    // 移除单个设备
    removeDevice (device) {
      const index = this.selectedDevices.findIndex(item => item.value === device.value);
      if (index > -1) {
        this.selectedDevices.splice(index, 1);
        // 同步更新 form.eqptGuidList
        this.form.eqptGuidList = this.selectedDevices.map(device => device.value);
      }
    },

    // 清空所有设备选择（DeleteProjNums方法）
    DeleteProjNums () {
      this.selectedDevices = [];
      this.form.eqptGuidList = [];
      this.$message.info('已清空设备选择');
    },

    // 根据设备GUID列表回填已选设备数据
    fillSelectedDevices (eqptGuidList) {
      if (!eqptGuidList || !Array.isArray(eqptGuidList) || eqptGuidList.length === 0) {
        this.selectedDevices = [];
        return;
      }

      this.selectedDevices = [];
      eqptGuidList.forEach(guid => {
        const device = this.eqptOptions.find(option => option.value === guid);
        if (device) {
          this.selectedDevices.push({
            value: device.value,
            label: device.label,
            eqptCode: device.eqptCode,
            eqptName: device.eqptName
          });
        }
      });
    },

    // ============ 标准选择相关方法 ============

    // 打开标准选择弹窗
    openStandardDialog () {
      this.standardDialogVisible = true;
      this.standardSearchKeyword = '';
      this.filteredStandardOptions = [...this.standardOptions];

      // 设置临时选择列表为当前已选择的标准
      this.tempSelectedStandards = [...this.selectedStandards];

      // 等待DOM更新后设置表格选中状态
      this.$nextTick(() => {
        if (this.$refs.standardTable) {
          // 清空之前的选择
          this.$refs.standardTable.clearSelection();

          // 设置已选择的标准为选中状态
          this.selectedStandards.forEach(selectedStandard => {
            const row = this.filteredStandardOptions.find(option => option.value === selectedStandard.value);
            if (row) {
              this.$refs.standardTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },

    // 标准搜索
    handleStandardSearch () {
      const keyword = this.standardSearchKeyword.toLowerCase();
      if (!keyword) {
        this.filteredStandardOptions = [...this.standardOptions];
      } else {
        this.filteredStandardOptions = this.standardOptions.filter(standard =>
          (standard.label && standard.label.toLowerCase().includes(keyword)) ||
          (standard.value && standard.value.toLowerCase().includes(keyword))
        );
      }

      // 重新设置表格选中状态
      this.$nextTick(() => {
        if (this.$refs.standardTable) {
          this.$refs.standardTable.clearSelection();
          this.tempSelectedStandards.forEach(selectedStandard => {
            const row = this.filteredStandardOptions.find(option => option.value === selectedStandard.value);
            if (row) {
              this.$refs.standardTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },

    // 标准选择变化
    handleStandardSelectionChange (selection) {
      this.tempSelectedStandards = selection.map(standard => ({
        value: standard.value,
        label: standard.label
      }));
    },

    // 确认标准选择
    confirmStandardSelection () {
      this.selectedStandards = [...this.tempSelectedStandards];

      // 更新 form.standardPidList 以保持数据格式一致
      this.form.standardPidList = this.selectedStandards.map(standard => standard.value);

      this.standardDialogVisible = false;
      this.$message.success(`已选择 ${this.selectedStandards.length} 个标准`);
    },

    // 取消标准选择
    cancelStandardSelection () {
      this.tempSelectedStandards = [];
      this.standardDialogVisible = false;
    },

    // 移除单个标准
    removeStandard (standard) {
      const index = this.selectedStandards.findIndex(item => item.value === standard.value);
      if (index > -1) {
        this.selectedStandards.splice(index, 1);
        // 同步更新 form.standardPidList
        this.form.standardPidList = this.selectedStandards.map(standard => standard.value);
      }
    },

    // 清空所有标准选择
    clearStandardSelection () {
      this.selectedStandards = [];
      this.form.standardPidList = [];
      this.$message.info('已清空标准选择');
    },

    // 根据标准PID列表回填已选标准数据
    fillSelectedStandards (standardPidList) {
      if (!standardPidList || !Array.isArray(standardPidList) || standardPidList.length === 0) {
        this.selectedStandards = [];
        return;
      }

      this.selectedStandards = [];
      standardPidList.forEach(pid => {
        const standard = this.standardOptions.find(option => option.value === pid);
        if (standard) {
          this.selectedStandards.push({
            value: standard.value,
            label: standard.label
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.app-container {
  background-color: #f5f7fa;
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  margin-bottom: 20px;
}

/* 树形节点样式 */
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 6px 0;
  transition: all 0.3s;
  border-radius: 4px;
}

.custom-tree-node > span:first-child {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 4px;
}

.custom-tree-node:hover {
  background-color: #f0f7ff;
}

.tree-actions {
  display: none;
  gap: 4px;
  flex-shrink: 0;
  margin-left: auto;
}

.custom-tree-node:hover .tree-actions {
  display: flex;
}

.tree-actions .el-button {
  padding: 4px 8px;
  font-size: 12px;
}

.node-indicator {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.node-category .node-indicator {
  background: #1e5799;
}

.node-industry .node-indicator {
  background: #409eff;
}

.node-type .node-indicator {
  background: #67c23a;
}

.node-project .node-indicator {
  background: #e6a23c;
}

/* 表单样式 */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.view-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.view-tip i {
  margin-right: 8px;
  font-size: 16px;
}

.el-tree /deep/ .is-current > .el-tree-node__content .custom-tree-node {
  background-color: #d9ecff !important;
  font-weight: bold;
  color: #409eff;
}

/* 设备选择相关样式 */
.selected-devices-tags {
  max-height: 100px;
  overflow-y: auto;
}

.device-dialog-content {
  padding: 0;
}

.search-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.device-list-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.selected-count {
  text-align: right;
  font-size: 14px;
}

/* 设备选择输入框样式 */
.el-input[readonly] .el-input__inner {
  cursor: pointer;
}

.el-input[readonly] .el-input__inner:hover {
  border-color: #409eff;
}

/* 标准选择相关样式 */
.selected-standards-tags {
  max-height: 100px;
  overflow-y: auto;
}

.standard-dialog-content {
  padding: 0;
}

.standard-list-section {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

/* 树形结构容器滚动条样式 */
.tree-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px); /* 根据实际页面高度调整 */
}

.tree-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;
}

/* 美化滚动条样式 */
.tree-wrapper::-webkit-scrollbar {
  width: 8px;
}

.tree-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.tree-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.tree-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 右侧表单滚动：内容过高时可滚动，避免底部按钮被遮挡 */
.form-scroll {
  max-height: calc(100vh - 245px);
  overflow: auto;
  padding-right: 6px;
}

/* level-4 检测内容：父项同一行显示输入框 + 操作按钮，子项在下方 */
.content-header-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.content-input {
  flex: 1;
}

.detail-list-under {
  margin-top: 10px;
  padding: 10px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px dashed #ebeef5;
}
.detail-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-input {
  flex: 1;
}

.detail-delete {
  color: #f56c6c;
}

.detail-empty {
  color: #c0c4cc;
  font-size: 12px;
}

.status-tag {
  min-width: 56px;
  text-align: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  color: #fff;
  user-select: none;
}

.status-ok {
  background-color: #67c23a;
}

.status-fail {
  background-color: #f56c6c;
}

.status-none {
  background-color: #909399;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>